<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import httpRequest from "./api/httpRequest";
export default {
  name: "App",
  created: async () => {},
  components: {},
};
</script>

<style>
@import "./assets/style/global.css";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: absolute;
  height: 100%;
  width: 100%;
}

.el-button--primary {
  background-color: #fcd535;
  border-color: #fcd535;
}

.el-message-box {
  max-width: 60vw;
}
</style>
